<template>
  <!-- BSL-PENCERE (Arayuz/Baslarken/BSL-PENCERE-PLANI.md): kart yerine ortada tek pencere, bir seferde
       tek adım. İş mümkünse pencerede tek tıkla yapılır (saat onayı, hazır liste, paylaş); değilse
       «Göster» sayfayı açar ve kısa tur başlatır, adım sayfada bitince pencere başarı ekranıyla döner. -->
  <Teleport to="body">
    <div v-if="gorunur" class="bsl-k-kok bsl-k-arka" @click.self="sonra" @keydown.esc.stop="sonra">
      <div ref="pencere" class="bsl-k-pencere" role="dialog" aria-modal="true" :aria-labelledby="'bsl-k-baslik'" tabindex="-1">
        <div class="bsl-k-cizim">
          <div v-if="ekran === 'basari' || ekran === 'son'" class="bsl-k-tamam" aria-hidden="true"></div>
          <span v-else aria-hidden="true" v-html="cizimSvg"></span>
          <button type="button" class="bsl-k-x" aria-label="Kapat" @click="sonra"><i class="pi pi-times" aria-hidden="true"></i></button>
        </div>

        <div v-if="seritGoster" class="bsl-k-serit" aria-hidden="true">
          <i v-for="(a, k) in adimlar" :key="a.kod" :class="{ 'bsl-k-d': a.bitti, 'bsl-k-c': k === sira && !a.bitti && ekran === 'adim' }"></i>
        </div>

        <!-- Karşılama / sektör -->
        <div v-if="ekran === 'karsilama' || ekran === 'sektor'" class="bsl-k-govde">
          <h3 id="bsl-k-baslik">{{ ekran === 'sektor' ? 'İşinizi seçin' : karsilamaBaslik }}</h3>
          <p>{{ kutucukSor ? 'Önce işinizi seçin; size göre hazırlayalım.' : 'Her adım tek tıkla biter. İstediğiniz an bırakıp sonra devam edebilirsiniz.' }}</p>
          <div v-if="kutucukSor" class="bsl-k-kutucuklar">
            <button v-for="k in kutucuklar" :key="k.deger" type="button" class="bsl-k-kutucuk" :class="{ 'bsl-k-secili': seciliKutucuk === k.deger }" :disabled="isleniyor" @click="sektorSec(k.deger)">
              <span class="bsl-k-ikon"><i :class="k.ikon" aria-hidden="true"></i></span>{{ k.ad }}
            </button>
          </div>
          <button v-else type="button" class="bsl-k-buyuk" :disabled="isleniyor" @click="baslayalim">Başlayalım</button>
          <button type="button" class="bsl-k-sonra" @click="sonra">{{ ekran === 'sektor' ? 'Vazgeç' : 'Sonra yaparım' }}</button>
        </div>

        <!-- Adım -->
        <div v-else-if="ekran === 'adim' && adim" class="bsl-k-govde">
          <div class="bsl-k-adimno">
            Adım {{ sira + 1 }} / {{ adimlar.length }}
            <template v-if="hatAdi"> · <button v-if="sektorDegisir" type="button" class="bsl-k-baglanti" @click="ekran = 'sektor'">{{ hatAdi }}</button><span v-else>{{ hatAdi }}</span></template>
          </div>
          <h3 id="bsl-k-baslik">{{ eksik ? 'Önce: ' + eksik.Baslik : adim.baslik }}</h3>
          <p>{{ eksik ? 'Bu adım için önce bunu yapalım.' : (orneksiz ? adim.metinOrneksiz : adim.metin) }}</p>

          <div v-if="yukleniyor" class="bsl-k-ozet bsl-k-yukleniyor">Hazırlanıyor…</div>

          <!-- onay: işletme bilgileri (IBS-3) -->
          <template v-else-if="tip === 'onay' && adim.isletme">
            <div class="bsl-k-ozet">
              <div v-for="s in isletmeOzet" :key="s.ad" class="bsl-k-satir"><span>{{ s.ad }}</span><span class="bsl-k-deger">{{ s.deger }}</span></div>
            </div>
            <div class="bsl-k-iki">
              <button type="button" class="bsl-k-buyuk" :disabled="isleniyor || !isletme" @click="isletmeOnayla">Doğru</button>
              <button type="button" class="bsl-k-ikincil" :disabled="isleniyor" @click="goster()">Düzenle</button>
            </div>
          </template>

          <!-- onay: saat -->
          <template v-else-if="tip === 'onay'">
            <div class="bsl-k-ozet">
              <div v-for="s in saatOzet" :key="s.gun" class="bsl-k-satir"><span>{{ s.gun }}</span><span>{{ s.saat }}</span></div>
              <div v-if="subeler.length > 1" class="bsl-k-not">{{ subeler.length }} şubenizin kayıtlı saatleri olduğu gibi onaylanır.</div>
            </div>
            <div class="bsl-k-iki">
              <button type="button" class="bsl-k-buyuk" :disabled="isleniyor" @click="saatOnayla">Bu saatler uygun</button>
              <button type="button" class="bsl-k-ikincil" :disabled="isleniyor" @click="goster()">Değiştir</button>
            </div>
          </template>

          <!-- hazır liste -->
          <template v-else-if="tip === 'hazir'">
            <div class="bsl-k-ozet">
              <div v-for="o in ornekOzet.ilk" :key="o.ad" class="bsl-k-satir"><span><span class="bsl-k-tik" aria-hidden="true"></span>{{ o.ad }}</span><span>{{ o.deger }}</span></div>
              <div v-if="ornekOzet.kalan" class="bsl-k-not">ve {{ ornekOzet.kalan }} tane daha</div>
            </div>
            <div class="bsl-k-iki">
              <button type="button" class="bsl-k-buyuk" :disabled="isleniyor" @click="ornekEkle">{{ ornekOzet.tek ? 'Oluştur' : 'Bunları ekle' }}</button>
              <button type="button" class="bsl-k-ikincil" :disabled="isleniyor" @click="goster()">{{ adim.dugme || 'Kendim eklerim' }}</button>
            </div>
            <button v-if="!ornekOzet.tek" type="button" class="bsl-k-sonra bsl-k-sonra--yakin" @click="ornekDuzenle">Değiştirerek ekle</button>
          </template>

          <!-- müşteri -->
          <template v-else-if="tip === 'musteri'">
            <button type="button" class="bsl-k-buyuk" @click="musteriAcik = true">{{ eksik ? 'Müşteri ekle' : adim.dugme }}</button>
          </template>

          <!-- paylaş -->
          <template v-else-if="tip === 'paylas'">
            <div v-if="paylasUrl" class="bsl-k-ozet bsl-k-url" :title="paylasUrl">{{ paylasUrl }}</div>
            <div v-else class="bsl-k-ozet bsl-k-yukleniyor">{{ paylasHata || 'Bağlantı bulunamadı.' }}</div>
            <button type="button" class="bsl-k-buyuk bsl-k-wa" :disabled="!paylasUrl || isleniyor" @click="whatsapp"><i class="pi pi-whatsapp" aria-hidden="true"></i>WhatsApp'ta paylaş</button>
            <button type="button" class="bsl-k-ikincil bsl-k-ust-bosluk" :disabled="!paylasUrl || isleniyor" @click="kopyala">Bağlantıyı kopyala</button>
          </template>

          <!-- göster -->
          <template v-else>
            <button type="button" class="bsl-k-buyuk" @click="goster()">{{ eksik ? 'Göster' : (orneksiz ? adim.dugmeOrneksiz : (adim.dugme || 'Göster')) }}</button>
          </template>

          <button type="button" class="bsl-k-sonra" @click="sonra">Sonra yaparım</button>
        </div>

        <!-- Başarı -->
        <div v-else-if="ekran === 'basari'" class="bsl-k-govde bsl-k-orta">
          <h3 id="bsl-k-baslik">Harika, bitti!</h3>
          <p v-if="adim">Sıradaki: <strong>{{ adim.ad }}</strong></p>
          <button type="button" class="bsl-k-buyuk" @click="devam">Devam et</button>
          <button type="button" class="bsl-k-sonra" @click="sonra">Sonra yaparım</button>
        </div>

        <!-- Son -->
        <div v-else class="bsl-k-govde bsl-k-orta">
          <h3 id="bsl-k-baslik">{{ bsl.pencereHat === 'ANA' ? 'Hazırsınız!' : modulAdi + ' hazır!' }}</h3>
          <p>Bir şeye takılırsanız sayfa başlığındaki <strong>?</strong> düğmesi o ekranı adım adım gösterir.</p>
          <button type="button" class="bsl-k-buyuk" @click="kapat">Başlayalım</button>
        </div>
      </div>
    </div>
  </Teleport>

  <HizliMusteri v-model:visible="musteriAcik" @kaydedildi="musteriKaydedildi" />
</template>

<script>
import { bsl, durumYukle, kullaniciIslem, cevapKaydet, turIste, pencereIste, ornekAc } from "@/baslarken/durum";
import { hatAdimlari, KUTUCUKLAR, MODUL_HATLARI, anaHatKutucugu } from "@/baslarken/hatlar";
import { MADDE_TURU, MADDE_PENCERE } from "@/baslarken/turlar";
import { BAGLANTI_TIPLERI, baglantiListesi } from "@/baslarken/baglantilar";
import HizliMusteri from "./HizliMusteri.vue";

const GUN_AD = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
const VARSAYILAN = { gunler: [1, 2, 3, 4, 5], bas: "09:00", bit: "18:00" };

const CIZIM = {
  karsilama: '<svg width="150" height="110" viewBox="0 0 150 110"><circle cx="75" cy="55" r="44" fill="var(--bsl-yuzey)"/><path d="M58 50c0-10 8-17 17-17s17 7 17 17" stroke="var(--bsl-vurgu)" stroke-width="5" fill="none" stroke-linecap="round"/><circle cx="64" cy="62" r="4" fill="var(--bsl-murekkep)"/><circle cx="86" cy="62" r="4" fill="var(--bsl-murekkep)"/><path d="M66 74q9 8 18 0" stroke="var(--bsl-murekkep)" stroke-width="4" fill="none" stroke-linecap="round"/></svg>',
  saat: '<svg width="150" height="110" viewBox="0 0 150 110"><circle cx="75" cy="55" r="40" fill="var(--bsl-yuzey)"/><circle cx="75" cy="55" r="40" fill="none" stroke="var(--bsl-vurgu)" stroke-width="5"/><path d="M75 33v22l15 10" stroke="var(--bsl-murekkep)" stroke-width="5" fill="none" stroke-linecap="round"/></svg>',
  liste: '<svg width="150" height="110" viewBox="0 0 150 110"><rect x="30" y="18" width="90" height="74" rx="12" fill="var(--bsl-yuzey)"/><rect x="42" y="32" width="12" height="12" rx="3" fill="var(--bsl-vurgu)"/><rect x="60" y="34" width="46" height="8" rx="4" fill="var(--bsl-murekkep3)"/><rect x="42" y="52" width="12" height="12" rx="3" fill="var(--bsl-vurgu)"/><rect x="60" y="54" width="38" height="8" rx="4" fill="var(--bsl-murekkep3)"/><rect x="42" y="72" width="12" height="12" rx="3" fill="var(--bsl-vurgu)"/><rect x="60" y="74" width="42" height="8" rx="4" fill="var(--bsl-murekkep3)"/></svg>',
  takvim: '<svg width="150" height="110" viewBox="0 0 150 110"><rect x="30" y="20" width="90" height="72" rx="12" fill="var(--bsl-yuzey)"/><rect x="30" y="20" width="90" height="18" rx="9" fill="var(--bsl-vurgu)"/><rect x="44" y="48" width="16" height="12" rx="3" fill="var(--bsl-yuzey3)"/><rect x="67" y="48" width="16" height="12" rx="3" fill="var(--bsl-vurgu)"/><rect x="90" y="48" width="16" height="12" rx="3" fill="var(--bsl-yuzey3)"/><rect x="44" y="68" width="16" height="12" rx="3" fill="var(--bsl-yuzey3)"/><rect x="67" y="68" width="16" height="12" rx="3" fill="var(--bsl-yuzey3)"/></svg>',
  baglanti: '<svg width="150" height="110" viewBox="0 0 150 110"><rect x="44" y="12" width="62" height="88" rx="12" fill="var(--bsl-yuzey)"/><rect x="54" y="26" width="42" height="8" rx="4" fill="var(--bsl-murekkep3)"/><rect x="54" y="42" width="42" height="12" rx="4" fill="var(--bsl-yuzey3)"/><rect x="54" y="60" width="42" height="12" rx="4" fill="var(--bsl-yuzey3)"/><rect x="54" y="80" width="42" height="11" rx="5" fill="var(--bsl-vurgu)"/><circle cx="112" cy="26" r="13" fill="#25D366"/></svg>',
  kisi: '<svg width="150" height="110" viewBox="0 0 150 110"><rect x="32" y="20" width="86" height="70" rx="12" fill="var(--bsl-yuzey)"/><circle cx="58" cy="48" r="11" fill="var(--bsl-vurgu)"/><path d="M42 76c2-9 9-14 16-14s14 5 16 14" fill="var(--bsl-vurgu)"/><rect x="80" y="40" width="28" height="7" rx="3.5" fill="var(--bsl-murekkep3)"/><rect x="80" y="54" width="22" height="7" rx="3.5" fill="var(--bsl-yuzey3)"/><rect x="80" y="68" width="26" height="7" rx="3.5" fill="var(--bsl-yuzey3)"/></svg>',
  isletme: '<svg width="150" height="110" viewBox="0 0 150 110"><rect x="34" y="30" width="82" height="64" rx="10" fill="var(--bsl-yuzey)"/><path d="M28 40l10-20h74l10 20z" fill="var(--bsl-vurgu)"/><rect x="46" y="50" width="22" height="16" rx="3" fill="var(--bsl-yuzey3)"/><rect x="82" y="50" width="22" height="44" rx="3" fill="var(--bsl-murekkep3)"/><rect x="46" y="74" width="22" height="8" rx="3" fill="var(--bsl-yuzey3)"/></svg>',
  satis: '<svg width="150" height="110" viewBox="0 0 150 110"><rect x="36" y="16" width="78" height="80" rx="12" fill="var(--bsl-yuzey)"/><rect x="48" y="30" width="54" height="8" rx="4" fill="var(--bsl-murekkep3)"/><rect x="48" y="46" width="40" height="7" rx="3.5" fill="var(--bsl-yuzey3)"/><rect x="48" y="58" width="46" height="7" rx="3.5" fill="var(--bsl-yuzey3)"/><rect x="48" y="76" width="54" height="11" rx="5" fill="var(--bsl-vurgu)"/></svg>',
};

function hhmm(v) {
  return (v || "").toString().slice(0, 5);
}

// BSL-D3 (B-15): SubeGerekliKart kullanan sayfalar.
const SUBELI_YOLLAR = ["/randevu/ayarlar", "/studio/ayarlar", "/studio/dersyeni"];

export default {
  name: "KurulumPenceresi",
  components: { HizliMusteri },
  data() {
    return {
      bsl,
      ekran: "adim",
      sira: 0,
      kutucuklar: KUTUCUKLAR,
      seciliKutucuk: null,
      isleniyor: false,
      yukleniyor: false,
      musteriAcik: false,
      // adım verileri
      subeler: [],
      saatler: [],        // [{ SubeGuid, gunler: [...], gunSatirlari: [...] | null, bas, bit }]
      ornek: null,
      isletme: null,      // IBS-3: GetIsletmeBilgi.Sirket
      paylasUrl: "",
      paylasHata: "",
    };
  },
  computed: {
    gorunur() {
      return bsl.pencereAcik && !this.musteriAcik && !!bsl.durum && !bsl.durum.Gizli;
    },
    adimlar() {
      return hatAdimlari(bsl.durum, bsl.pencereHat);
    },
    adim() {
      return this.adimlar[this.sira] || null;
    },
    eksik() {
      return (this.adim && this.adim.madde.EksikOnkosul) || null;
    },
    // BSL-D3 (B-16): hazır adımın örneği yoksa metin ve düğme işi söyler («Ürün ekle»).
    orneksiz() {
      return !!this.adim && !this.eksik && this.adim.tip === "hazir" && !this.adim.madde.OrnekVar && !!this.adim.metinOrneksiz;
    },
    // Önkoşul eksikse adım önkoşulun tipinde davranır (MUS-ILK → müşteri penceresi, diğerleri göster).
    tip() {
      if (!this.adim) return null;
      if (this.eksik) return this.eksik.Kod === "MUS-ILK" ? "musteri" : "goster";
      if (this.adim.tip === "hazir" && !this.adim.madde.OrnekVar) return "goster";
      return this.adim.tip;
    },
    cizimSvg() {
      if (this.ekran === "karsilama" || this.ekran === "sektor") return CIZIM.karsilama;
      return CIZIM[(this.adim && this.adim.cizim) || "liste"] || CIZIM.liste;
    },
    seritGoster() {
      return this.adimlar.length > 1 && this.ekran !== "karsilama" && this.ekran !== "sektor";
    },
    kutucukSor() {
      return this.ekran === "sektor" || !!(bsl.durum && bsl.durum.SoruSor);
    },
    karsilamaBaslik() {
      const n = this.adimlar.filter((a) => !a.bitti).length;
      return n > 1 ? `Hoş geldiniz! ${n} kısa adımda hazırsınız` : "Hoş geldiniz!";
    },
    hatAdi() {
      if (bsl.pencereHat !== "ANA") return this.modulAdi;
      return anaHatKutucugu(bsl.durum).ad;
    },
    modulAdi() {
      return (MODUL_HATLARI[bsl.pencereHat] || {}).ad || "";
    },
    sektorDegisir() {
      return bsl.pencereHat === "ANA" && !!(bsl.durum && bsl.durum.SektorDegistirebilir);
    },
    saatOzet() {
      const s = this.saatler[0];
      if (!s) return [];
      // Aynı saatli ardışık günler tek satır: «Pazartesi – Cuma · 09:00 – 18:00».
      const sira = [1, 2, 3, 4, 5, 6, 0];
      const satirlar = sira.map((g) => {
        const r = s.gunSatirlari ? s.gunSatirlari.find((x) => Number(x.Gun) === g) : null;
        const acik = r ? !r.KapaliMi : s.gunler.includes(g);
        return { g, saat: acik ? `${hhmm(r ? r.Baslama : s.bas)} – ${hhmm(r ? r.Bitis : s.bit)}` : "Kapalı" };
      });
      const gruplar = [];
      for (const x of satirlar) {
        const son = gruplar[gruplar.length - 1];
        if (son && son.saat === x.saat) son.bit = x.g;
        else gruplar.push({ bas: x.g, bit: x.g, saat: x.saat });
      }
      return gruplar.map((x) => ({ gun: x.bas === x.bit ? GUN_AD[x.bas] : `${GUN_AD[x.bas]} – ${GUN_AD[x.bit]}`, saat: x.saat }));
    },
    isletmeOzet() {
      const s = this.isletme;
      if (!s) return [];
      const yok = "Girilmemiş";
      const adres = (s.Adres || "").trim() || [s.AcikAdres, s.Mahalle, s.Ilce, s.Il].filter((x) => x && String(x).trim()).join(", ");
      return [
        { ad: "Ad", deger: s.Ad || yok },
        { ad: "Telefon", deger: s.TelefonNo || yok },
        { ad: "E-posta", deger: s.MailAdres || yok },
        { ad: "Adres", deger: adres || yok },
        { ad: "Logo", deger: s.Logo ? "Var" : "Yok" },
      ];
    },
    ornekOzet() {
      const p = this.ornek;
      if (!p) return { ilk: [], kalan: 0, tek: false };
      let liste = [];
      if (p.Koleksiyon) liste = [{ ad: p.Koleksiyon.Ad, deger: "yayındaki tüm yazılar" }];
      else if (Array.isArray(p.Tipler) && p.Tipler.length) liste = p.Tipler.filter((t) => !t.Var).map((t) => ({ ad: t.Ad, deger: t.SureDakika ? t.SureDakika + " dk" : "" }));
      else if (Array.isArray(p.YmKategoriler) && p.YmKategoriler.length) liste = p.YmKategoriler.filter((k) => !k.Var).map((k) => ({ ad: k.Ad, deger: "" }));
      else liste = (p.Urunler || []).filter((u) => !u.Var).map((u) => ({ ad: u.Ad, deger: u.Fiyat != null && u.Fiyat !== "" ? Number(u.Fiyat).toLocaleString("tr-TR") + " ₺" : "" }));
      return { ilk: liste.slice(0, 4), kalan: Math.max(0, liste.length - 4), tek: !!p.Koleksiyon };
    },
  },
  watch: {
    "bsl.pencereAcik"(acik) {
      if (acik) this.ac();
      else this.musteriAcik = false;
    },
    // «Göster» adımı sayfada bittiyse (durum tazelendi) pencere başarı ekranıyla döner.
    "bsl.durum"() {
      this.bekleyeniDene();
    },
    // BSL-D2 (B-12): tur kapanınca (ya da hedef bulunamayıp vazgeçilince) bekleyen dönüş denenir.
    "bsl.turAktif"(v) {
      if (!v) this.bekleyeniDene();
    },
    "bsl.turHazirlik"(v) {
      if (!v) this.bekleyeniDene();
    },
  },
  methods: {
    // BSL-D2 (B-12): tur istenmiş, hedef arıyor ya da açıkken bekleyen adım silinmez, pencere açılmaz;
    // tur bitince «Harika, bitti!» ile döner (aynı anda tek deneyim).
    bekleyeniDene() {
      const b = bsl.bekleyenAdim;
      const d = bsl.durum;
      if (!b || !d || d.Gizli) return;
      if (bsl.turIstegi || bsl.turAktif || bsl.turHazirlik) return;
      const m = (d.Maddeler || []).find((x) => x.Kod === b.kod);
      if (!m || !(m.Tamam || m.Atlandi)) return;
      bsl.bekleyenAdim = null;
      if (bsl.pencereAcik) return;
      bsl.pencereHat = b.hat;
      bsl.pencereEkran = "basari";
      bsl.pencereAcik = true;
    },
    ac() {
      const istenen = bsl.pencereEkran;
      bsl.pencereEkran = null;
      this.seciliKutucuk = null;
      if (istenen === "karsilama" || istenen === "sektor") this.ekran = istenen;
      // İş seçilmemişse (karşılamada «Sonra» denmiş) önce kutucuklar.
      else if (bsl.pencereHat === "ANA" && bsl.durum.SoruSor && istenen !== "basari") this.ekran = "sektor";
      else this.siradakine(istenen === "basari" ? "basari" : "adim");
      // BSL-D3 B-21: ekran hemen kurulur, durum arkadan tazelenir (başka sayfada biten adım
      // yenilemeden görünsün); sıradaki adım değiştiyse ekran yeniden kurulur.
      if (istenen !== "basari") {
        durumYukle(true).then(() => {
          if (!bsl.pencereAcik || (this.ekran !== "adim" && this.ekran !== "son")) return;
          const i = this.adimlar.findIndex((a) => !a.bitti);
          if ((i < 0 && this.ekran !== "son") || (i >= 0 && (this.ekran === "son" || i !== this.sira))) this.siradakine();
        });
      }
      this.$nextTick(() => {
        const el = this.$refs.pencere;
        if (!el) return;
        const d = el.querySelector(".bsl-k-buyuk, .bsl-k-kutucuk");
        (d || el).focus({ preventScroll: true });
      });
    },
    // İlk bitmemiş adıma geç; hepsi bittiyse son ekran.
    siradakine(ekran = "adim") {
      const i = this.adimlar.findIndex((a) => !a.bitti);
      if (i < 0) { this.ekran = "son"; return; }
      this.sira = i;
      this.ekran = ekran;
      this.adimYukle();
    },
    devam() {
      this.ekran = "adim";
      this.adimYukle();
    },
    adimYukle() {
      this.ornek = null;
      this.isletme = null;
      this.paylasUrl = "";
      this.paylasHata = "";
      const a = this.adim;
      if (!a || this.eksik) return;
      if (this.tip === "onay" && a.isletme) this.isletmeYukle();
      else if (this.tip === "onay") this.saatYukle(a);
      else if (this.tip === "hazir") this.ornekYukle(a.kod);
      else if (this.tip === "paylas") this.paylasYukle(a.paylas);
    },

    // ---- karşılama / sektör ----
    async sektorSec(deger) {
      this.seciliKutucuk = deger;
      this.isleniyor = true;
      try {
        const res = await cevapKaydet(deger, null);
        if (res.status === 999) this.$toast.add({ severity: "warn", summary: "Uyarı", detail: res.data, life: 4000 });
        else if (res.status !== 200) { this.$toast.add({ severity: "error", summary: "Hata", detail: "Seçim kaydedilemedi.", life: 4000 }); return; }
        if (this.ekran === "karsilama") await kullaniciIslem("KarsilamaGoruldu");
        await durumYukle(true);
        this.siradakine();
      } catch {
        this.$toast.add({ severity: "error", summary: "Hata", detail: "Bağlantı hatası.", life: 4000 });
      } finally {
        this.isleniyor = false;
      }
    },
    async baslayalim() {
      this.isleniyor = true;
      try {
        await kullaniciIslem("KarsilamaGoruldu");
        await durumYukle(true);
      } catch { /* sessiz */ }
      this.isleniyor = false;
      this.siradakine();
    },

    // ---- onay: işletme bilgileri (IBS-3) ----
    isletmeYukle() {
      this.yukleniyor = true;
      this.$Servis("GET", "GetIsletmeBilgi", "")
        .then((res) => {
          if (res.status === 200 && res.data && res.data.Sirket) this.isletme = res.data.Sirket;
          else if (res.status === 999) this.$toast.add({ severity: "warn", summary: "Uyarı", detail: res.data, life: 4000 });
        })
        .catch(() => {})
        .finally(() => { this.yukleniyor = false; });
    },
    async isletmeOnayla() {
      this.isleniyor = true;
      try {
        const res = await kullaniciIslem("Onaylandi", this.adim.kod);
        if (res.status === 200) await this.bitti();
        else if (res.status === 999) this.$toast.add({ severity: "warn", summary: "Uyarı", detail: res.data, life: 4000 });
        else this.$toast.add({ severity: "error", summary: "Hata", detail: "Onay kaydedilemedi.", life: 4000 });
      } catch {
        this.$toast.add({ severity: "error", summary: "Hata", detail: "Bağlantı hatası.", life: 4000 });
      } finally {
        this.isleniyor = false;
      }
    },

    // ---- onay: çalışma saati ----
    async subeleriYukle() {
      if (this.subeler.length) return this.subeler;
      const res = await this.$Servis("GET", "GetSubeTablosu_Aktif_KullaniciYetkili", "");
      this.subeler = res.status === 200 && Array.isArray(res.data) ? res.data.filter((s) => s.SubeGuid) : [];
      return this.subeler;
    },
    async saatYukle(a) {
      this.yukleniyor = true;
      this.saatler = [];
      try {
        const subeler = await this.subeleriYukle();
        const sonuc = [];
        for (const s of subeler) {
          const uc = a.saat === "studio" ? "GetStudioCalismaSaati" : "GetRandevuCalismaSaati";
          const res = await this.$Servis("POST", uc, { SubeGuid: s.SubeGuid });
          if (res.status !== 200 || !res.data) continue;
          const d = res.data;
          const gunler = String(d.CalismaGun || "").split(",").map((x) => parseInt(x, 10)).filter((x) => x >= 0 && x <= 6);
          const bas = hhmm(d.IsBaslama || d.VarsayilanBaslama) || VARSAYILAN.bas;
          const bit = hhmm(d.IsBitis || d.VarsayilanBitis) || VARSAYILAN.bit;
          sonuc.push({
            SubeGuid: s.SubeGuid,
            gunler: gunler.length ? gunler : VARSAYILAN.gunler,
            gunSatirlari: Array.isArray(d.Gunler) && d.Gunler.length ? d.Gunler : null,
            bas, bit,
          });
        }
        this.saatler = sonuc;
        if (!sonuc.length) this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Şube saatleri okunamadı; «Değiştir» ile ayarlardan girebilirsiniz.", life: 4000 });
      } catch {
        this.saatler = [];
      } finally {
        this.yukleniyor = false;
      }
    },
    async saatOnayla() {
      if (!this.saatler.length) return this.goster();
      const studio = this.adim.saat === "studio";
      this.isleniyor = true;
      try {
        for (const s of this.saatler) {
          let res;
          if (studio) {
            res = await this.$Servis("POST", "UpdateStudioCalismaSaati", { SubeGuid: s.SubeGuid, CalismaGun: s.gunler.join(","), IsBaslama: s.bas, IsBitis: s.bit });
          } else {
            const Gunler = s.gunSatirlari
              ? s.gunSatirlari.map((r) => ({ Gun: Number(r.Gun), KapaliMi: !!r.KapaliMi, Baslama: hhmm(r.Baslama), Bitis: hhmm(r.Bitis), MolaBaslama: hhmm(r.MolaBaslama), MolaBitis: hhmm(r.MolaBitis) }))
              : [0, 1, 2, 3, 4, 5, 6].map((g) => ({ Gun: g, KapaliMi: !s.gunler.includes(g), Baslama: s.bas, Bitis: s.bit, MolaBaslama: "", MolaBitis: "" }));
            res = await this.$Servis("POST", "SetRandevuCalismaSaati", { SubeGuid: s.SubeGuid, pRandevuPersonel: "", Gunler });
          }
          if (res.status === 999) { this.$toast.add({ severity: "warn", summary: "Uyarı", detail: res.data, life: 5000 }); return; }
          if (res.status !== 200) { this.$toast.add({ severity: "error", summary: "Hata", detail: "Saatler kaydedilemedi.", life: 4000 }); return; }
        }
        await this.bitti();
      } catch {
        this.$toast.add({ severity: "error", summary: "Hata", detail: "Bağlantı hatası.", life: 4000 });
      } finally {
        this.isleniyor = false;
      }
    },

    // ---- hazır liste ----
    ornekYukle(kod) {
      this.yukleniyor = true;
      this.$Servis("GET", "GetBaslarkenOrnek?MaddeKod=" + encodeURIComponent(kod), "")
        .then((res) => {
          if (res.status === 200 && res.data) this.ornek = res.data;
          else if (res.status === 999) this.$toast.add({ severity: "warn", summary: "Uyarı", detail: res.data, life: 4000 });
        })
        .catch(() => {})
        .finally(() => { this.yukleniyor = false; });
    },
    // Önerilen değerlerle (OrnekOnizleme'nin «Ekle»siyle aynı istek, değiştirmeden).
    async ornekEkle() {
      const p = this.ornek;
      if (!p) return this.goster();
      const Fiyatlar = (p.Urunler || []).map((u) => ({
        Anahtar: u.Anahtar,
        Fiyat: u.Fiyat == null ? "" : String(u.Fiyat),
        Seans: u.PaketSeans != null ? String(u.PaketSeans) : "",
        Gun: u.PaketGun != null ? String(u.PaketGun) : "",
      }));
      const Sureler = (p.Tipler || []).map((t) => ({ Anahtar: t.Anahtar, Sure: t.SureDakika == null ? "" : String(t.SureDakika) }));
      const Sorumlular = (p.YmKategoriler || []).map((k) => ({ Anahtar: k.Anahtar, Kullanici: Number(p.VarsayilanSorumlu) || 0 }));
      this.isleniyor = true;
      try {
        const res = await this.$Servis("POST", "SetBaslarkenOrnek", { MaddeKod: this.adim.kod, Fiyatlar, Sureler, Sorumlular });
        if (res.status === 200) {
          bsl.ornekSayac++;
          // BSL-BLG §4: koleksiyon açılınca «Siteme Ekle» sekmesi + turu (pencere kapanır).
          if (res.data && res.data.BlogKoleksiyon_rowid) {
            await durumYukle(true);
            bsl.pencereAcik = false;
            turIste("koleksiyonSiteme");
            this.$router.push({ path: "/blog/koleksiyon/" + res.data.BlogKoleksiyon_rowid });
            return;
          }
          await this.bitti();
        } else if (res.status === 999) {
          this.$toast.add({ severity: "warn", summary: "Uyarı", detail: res.data, life: 4000 });
        } else {
          this.$toast.add({ severity: "error", summary: "Hata", detail: "Eklenemedi.", life: 4000 });
        }
      } catch {
        this.$toast.add({ severity: "error", summary: "Hata", detail: "Bağlantı hatası.", life: 4000 });
      } finally {
        this.isleniyor = false;
      }
    },
    ornekDuzenle() {
      bsl.bekleyenAdim = { kod: this.adim.kod, hat: bsl.pencereHat };
      bsl.pencereAcik = false;
      ornekAc(this.adim.kod);
    },

    // ---- müşteri ----
    async musteriKaydedildi() {
      this.musteriAcik = false;
      await this.bitti();
    },

    // ---- paylaş ----
    paylasYukle(tip) {
      this.yukleniyor = true;
      this.$Servis("POST", "GetSirketBaglantiInfo", {})
        .then((res) => {
          if (res.status === 200 && res.data) {
            const l = baglantiListesi(tip, res.data.SubeListesi || [], res.data.SirketGuid || "");
            this.paylasUrl = l.length ? l[0].url : "";
          } else if (res.status === 999) {
            this.paylasHata = res.data;
          } else {
            this.paylasHata = "Bağlantı yüklenemedi.";
          }
        })
        .catch(() => { this.paylasHata = "Bağlantı hatası."; })
        .finally(() => { this.yukleniyor = false; });
    },
    whatsapp() {
      const t = BAGLANTI_TIPLERI[this.adim.paylas] || {};
      window.open("https://wa.me/?text=" + encodeURIComponent((t.mesaj ? t.mesaj + " " : "") + this.paylasUrl), "_blank", "noopener");
      this.paylasildi();
    },
    kopyala() {
      navigator.clipboard.writeText(this.paylasUrl)
        .then(() => {
          this.$toast.add({ severity: "success", summary: "Kopyalandı", detail: "Bağlantı panoda; istediğiniz yere yapıştırın.", life: 2500 });
          this.paylasildi();
        })
        .catch(() => this.$toast.add({ severity: "error", summary: "Hata", detail: "Kopyalanamadı; bağlantıyı seçip elle kopyalayın.", life: 3000 }));
    },
    async paylasildi() {
      this.isleniyor = true;
      try {
        await kullaniciIslem("Paylasildi", this.adim.kod);
        await this.bitti();
      } catch { /* sessiz */ }
      this.isleniyor = false;
    },

    // ---- göster: sayfa + kısa tur ----
    async goster() {
      const a = this.adim;
      if (!a || this.isleniyor) return;
      const hedef = this.eksik || a.madde;
      const kod = hedef.Kod;
      const url = hedef.Url ? await this.subeliAdres(hedef.Url) : null;
      bsl.bekleyenAdim = { kod, hat: bsl.pencereHat };
      bsl.pencereAcik = false;
      const tur = MADDE_TURU[kod];
      if (tur) turIste(tur, null, true);
      if (MADDE_PENCERE[kod]) pencereIste(MADDE_PENCERE[kod]);
      if (url) this.$router.push(this.hedefAdres(url));
    },
    // BSL-D3-3 (B-27): hedef sayfa zaten açıksa mevcut sorgu (ör. DanisanNo, SubeGuid) korunur,
    // adresin kendi parametreleri üstüne yazılır. Yol farklıysa adres aynen açılır.
    hedefAdres(url) {
      if (url.includes("#")) return url;
      const [yol, sorgu = ""] = url.split("?");
      if (yol !== this.$route.path) return url;
      const adresSorgu = Object.fromEntries(new URLSearchParams(sorgu));
      return { path: yol, query: { ...this.$route.query, ...adresSorgu } };
    },
    // BSL-D3 (B-15): şube isteyen sayfaya pencereden gidişte, tek yetkili şube varsa adrese eklenir
    // («Şube seçilmedi» kartı çıkmaz). Çok şubede ya da liste alınamazsa adres aynı kalır (SKD K7).
    async subeliAdres(url) {
      const [yol, sorgu = ""] = url.split("?");
      if (!SUBELI_YOLLAR.includes(yol)) return url;
      const p = new URLSearchParams(sorgu);
      if (p.get("SubeGuid")) return url;
      this.isleniyor = true;
      try {
        const subeler = await this.subeleriYukle();
        if (subeler.length !== 1) return url;
        p.set("SubeGuid", subeler[0].SubeGuid);
        return yol + "?" + p.toString();
      } catch (e) {
        return url;
      } finally {
        this.isleniyor = false;
      }
    },

    // Pencerede biten adım: durum tazelenir, başarı ya da son ekran.
    async bitti() {
      await durumYukle(true);
      const i = this.adimlar.findIndex((a) => !a.bitti);
      if (i < 0) { this.ekran = "son"; return; }
      this.sira = i;
      this.ekran = "basari";
    },

    sonra() {
      if (this.ekran === "sektor" && bsl.durum && !bsl.durum.SoruSor) { this.siradakine(); return; }
      if (this.ekran === "karsilama") kullaniciIslem("KarsilamaGoruldu").then(() => durumYukle(true)).catch(() => {});
      this.kapat();
    },
    kapat() {
      bsl.pencereAcik = false;
    },
  },
};

</script>

<style>
/* Global: pencere body'ye teleport edilir. Renkler PrimeVue tokenlarından; koyu tema .my-app-dark. */
.bsl-k-kok {
  --bsl-yuzey: var(--p-surface-0, #fff);
  --bsl-yuzey2: var(--p-surface-100, #f1f4f7);
  --bsl-yuzey3: var(--p-surface-200, #e6ebf0);
  --bsl-murekkep: var(--p-surface-900, #121826);
  --bsl-murekkep2: var(--p-surface-600, #4a5567);
  --bsl-murekkep3: var(--p-surface-400, #8590a2);
  --bsl-cizgi: var(--p-surface-200, #e1e6ec);
  --bsl-vurgu: var(--p-primary-color, #0e9f6e);
  --bsl-vurgu-yazi: var(--p-primary-contrast-color, #fff);
  --bsl-vurgu-zemin: color-mix(in srgb, var(--bsl-vurgu) 13%, var(--bsl-yuzey));
  --bsl-karartma: rgba(9, 12, 20, 0.55);
  --bsl-golge: 0 30px 70px -20px rgba(9, 12, 20, 0.55);
}
.my-app-dark .bsl-k-kok {
  --bsl-yuzey: var(--p-surface-900, #121826);
  --bsl-yuzey2: var(--p-surface-800, #182030);
  --bsl-yuzey3: var(--p-surface-700, #222c3e);
  --bsl-murekkep: var(--p-surface-0, #e9edf4);
  --bsl-murekkep2: var(--p-surface-300, #aab4c5);
  --bsl-murekkep3: var(--p-surface-500, #6e7a90);
  --bsl-cizgi: var(--p-surface-700, #232d3f);
  --bsl-vurgu-zemin: color-mix(in srgb, var(--bsl-vurgu) 20%, var(--bsl-yuzey));
  --bsl-karartma: rgba(2, 4, 9, 0.72);
  --bsl-golge: 0 30px 80px -20px rgba(0, 0, 0, 0.9);
}
.bsl-k-arka {
  position: fixed;
  inset: 0;
  z-index: 1150;
  background: var(--bsl-karartma);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  backdrop-filter: blur(2px);
  animation: bslKSolma 0.2s ease;
}
@keyframes bslKSolma { from { opacity: 0; } }
.bsl-k-pencere {
  width: min(460px, 100%);
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  background: var(--bsl-yuzey);
  color: var(--bsl-murekkep);
  border-radius: 20px;
  box-shadow: var(--bsl-golge);
  outline: none;
  animation: bslKYuksel 0.28s cubic-bezier(0.2, 0.8, 0.2, 1);
}
@keyframes bslKYuksel { from { transform: translateY(16px) scale(0.98); opacity: 0; } }
.bsl-k-cizim {
  height: 150px;
  background: var(--bsl-vurgu-zemin);
  display: grid;
  place-items: center;
  position: relative;
}
.bsl-k-x {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 0;
  background: color-mix(in srgb, var(--bsl-yuzey) 75%, transparent);
  color: var(--bsl-murekkep2);
  cursor: pointer;
  display: grid;
  place-items: center;
}
.bsl-k-serit { display: flex; gap: 5px; padding: 16px 24px 0; }
.bsl-k-serit i { flex: 1; height: 5px; border-radius: 99px; background: var(--bsl-yuzey3); }
.bsl-k-serit i.bsl-k-d { background: var(--bsl-vurgu); }
.bsl-k-serit i.bsl-k-c { background: linear-gradient(90deg, var(--bsl-vurgu) 50%, var(--bsl-yuzey3) 50%); }
.bsl-k-govde { padding: 12px 24px 20px; }
.bsl-k-orta { text-align: center; padding-top: 20px; }
.bsl-k-adimno { font-size: 12px; font-weight: 600; color: var(--bsl-murekkep3); letter-spacing: 0.02em; }
.bsl-k-govde h3 { margin: 4px 0 6px; font-size: 21px; font-weight: 800; letter-spacing: -0.01em; text-wrap: balance; color: var(--bsl-murekkep); }
.bsl-k-govde p { margin: 0 0 18px; color: var(--bsl-murekkep2); font-size: 15px; line-height: 1.5; }
.bsl-k-kok button { font: inherit; cursor: pointer; }
.bsl-k-kok button:focus-visible { outline: 2px solid var(--bsl-vurgu); outline-offset: 2px; }
.bsl-k-kok button:disabled { opacity: 0.6; cursor: default; }
.bsl-k-buyuk {
  width: 100%;
  border: 0;
  border-radius: 12px;
  padding: 14px 18px;
  font-weight: 700;
  font-size: 15.5px;
  background: var(--bsl-vurgu);
  color: var(--bsl-vurgu-yazi);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.bsl-k-buyuk:hover:not(:disabled) { filter: brightness(1.06); }
.bsl-k-buyuk.bsl-k-wa { background: #25d366; color: #05361b; }
.bsl-k-ikincil {
  width: 100%;
  border: 1px solid var(--bsl-cizgi);
  background: var(--bsl-yuzey);
  color: var(--bsl-murekkep);
  border-radius: 12px;
  padding: 13px 16px;
  font-weight: 700;
  font-size: 14.5px;
}
.bsl-k-ikincil:hover:not(:disabled) { background: var(--bsl-yuzey2); }
.bsl-k-ust-bosluk { margin-top: 10px; }
.bsl-k-iki { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.bsl-k-sonra {
  display: block;
  margin: 12px auto 0;
  background: none;
  border: 0;
  color: var(--bsl-murekkep3);
  font-weight: 600;
  font-size: 13.5px;
  padding: 6px 10px;
  border-radius: 8px;
}
.bsl-k-sonra:hover { color: var(--bsl-murekkep); }
.bsl-k-sonra--yakin { margin-top: 6px; }
.bsl-k-baglanti { background: none; border: 0; padding: 0; color: var(--bsl-vurgu); font-weight: 700; text-decoration: underline; text-underline-offset: 2px; }
.bsl-k-kutucuklar { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 4px; }
.bsl-k-kutucuk {
  border: 1.5px solid var(--bsl-cizgi);
  background: var(--bsl-yuzey);
  color: var(--bsl-murekkep);
  border-radius: 14px;
  padding: 14px 12px;
  text-align: left;
  display: flex;
  gap: 10px;
  align-items: center;
  font-weight: 700;
  font-size: 14.5px;
}
.bsl-k-kutucuk:hover:not(:disabled), .bsl-k-kutucuk.bsl-k-secili { border-color: var(--bsl-vurgu); background: var(--bsl-vurgu-zemin); }
.bsl-k-ikon { width: 34px; height: 34px; border-radius: 10px; background: var(--bsl-yuzey3); display: grid; place-items: center; flex: none; color: var(--bsl-vurgu); }
.bsl-k-ozet { background: var(--bsl-yuzey2); border-radius: 12px; padding: 12px 14px; margin: -4px 0 16px; font-size: 14px; color: var(--bsl-murekkep); }
.bsl-k-satir { display: flex; justify-content: space-between; gap: 12px; padding: 4px 0; }
.bsl-k-satir span:last-child { font-weight: 700; font-variant-numeric: tabular-nums; white-space: nowrap; }
.bsl-k-satir span.bsl-k-deger { white-space: normal; text-align: right; overflow-wrap: anywhere; min-width: 0; }
.bsl-k-not { font-size: 12.5px; color: var(--bsl-murekkep3); padding-top: 4px; }
.bsl-k-yukleniyor { color: var(--bsl-murekkep3); text-align: center; }
.bsl-k-url { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 12.5px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bsl-k-tik { width: 20px; height: 20px; border-radius: 6px; background: var(--bsl-vurgu); display: inline-grid; place-items: center; margin-right: 8px; vertical-align: -4px; }
.bsl-k-tik::after { content: ""; width: 8px; height: 4px; border-left: 2px solid var(--bsl-vurgu-yazi); border-bottom: 2px solid var(--bsl-vurgu-yazi); transform: rotate(-45deg) translate(1px, -1px); }
.bsl-k-tamam { width: 72px; height: 72px; border-radius: 50%; background: var(--bsl-vurgu); display: grid; place-items: center; animation: bslKPat 0.4s cubic-bezier(0.2, 1.4, 0.4, 1); }
.bsl-k-tamam::after { content: ""; width: 26px; height: 13px; border-left: 5px solid var(--bsl-vurgu-yazi); border-bottom: 5px solid var(--bsl-vurgu-yazi); transform: rotate(-45deg) translate(2px, -3px); }
@keyframes bslKPat { from { transform: scale(0.4); opacity: 0; } }
@media (max-width: 640px) {
  .bsl-k-iki, .bsl-k-kutucuklar { grid-template-columns: 1fr; }
  .bsl-k-cizim { height: 120px; }
  .bsl-k-govde { padding: 12px 18px 18px; }
}
@media (prefers-reduced-motion: reduce) {
  .bsl-k-arka, .bsl-k-pencere, .bsl-k-tamam { animation: none; }
}
</style>
